var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "175px",
    height: "175px",
    viewBox: "0 0 175 175",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chart/icon/dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chart/icon/dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "analytics"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B7C140",
    x: 19.5454545,
    y: 27.7272727,
    width: 50.4545455,
    height: 34.7962382,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 125.909091,
    y: 27.7272727,
    width: 27.2727273,
    height: 35.6643357,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#243B81",
    x: 125.909091,
    y: 67.2727273,
    width: 27.2727273,
    height: 40.9090909,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B7C140",
    x: 75,
    y: 89.0909091,
    width: 20.4545455,
    height: 19.0909091,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B7C140",
    x: 100.454545,
    y: 89.0909091,
    width: 20.4545455,
    height: 19.0909091,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#243B81",
    x: 75,
    y: 66.8181818,
    width: 20.4545455,
    height: 19.0909091,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5A623",
    x: 100.454545,
    y: 66.8181818,
    width: 20.4545455,
    height: 19.0909091,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 75,
    y: 45,
    width: 20.4545455,
    height: 19.0909091,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 100.454545,
    y: 45,
    width: 20.4545455,
    height: 19.0909091,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5A623",
    x: 75,
    y: 27.7272727,
    width: 20.4545455,
    height: 14.0909091,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#243B81",
    x: 100.454545,
    y: 27.7272727,
    width: 20.4545455,
    height: 14.0909091,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#243B81",
    x: 19.5454545,
    y: 66.8181818,
    width: 50.4545455,
    height: 80.4545455,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.454545,114.247159 L155.454545,146.207386 C155.454545,146.795758 154.947211,147.272727 154.321383,147.272727 L76.1331626,147.272727 C75.5073342,147.272727 75,146.795758 75,146.207386 L75,114.247159 C75,113.658788 75.5073342,113.181818 76.1331626,113.181818 L154.321383,113.181818 C154.947211,113.181818 155.454545,113.658788 155.454545,114.247159 Z",
    id: "Rectangle",
    fill: "#243B81"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.5552871d8c8958e8aed1b120dcd2c847.svg";
export { ForwardRef as ReactComponent };